import Slider from 'react-slick';
import React, { useEffect, useState } from 'react';
import '../../../styles/components/KnowledgeCentre/KnowledgeCentre.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import IconButton from '@mui/material/IconButton';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ShareIcon from '@mui/icons-material/Share';
import ModalVideo from 'react-modal-video';
import Play from '../../../assets/play.png';
import KnowledgeCentreConstants, {
  ANALYTICS_EVENTS,
} from '../../../constants/MitraContentConstants';
import DialolPopup from './DialogPopup';
import useMoengage from '../../../hooks/useMoengage';

const MODE = 'Whatsapp';

export default function Carousel(props) {
  const { post } = props;
  const [sliderRef, setSliderRef] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [share, setShare] = React.useState(false);
  const [currentVideoId, setCurrentVideoId] = React.useState('rZsYkVsf1fU');
  const [currentVideoLink, setCurrentVideoLink] = React.useState('link not available');
  const [, , triggerContentInteractedEvent] = useMoengage();
  const [likedItems, setLikedItems] = useState([]);

  const getUpdatedSelectedLikeButton = id => {
    const items = likedItems.slice();
    const index = likedItems.indexOf(id);
    if (index >= 0) {
      items.splice(index, 1);
      setLikedItems(items);
    } else {
      items.push(id);
      setLikedItems(items);
    }
  };

  const handleClickOpen = id => {
    setOpen(true);
    setCurrentVideoId(id);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickShare = (id, url, containerPosition) => {
    setShare(true);
    setCurrentVideoLink(url);
    triggerContentInteractedEvent(ANALYTICS_EVENTS.VIDEO_SHARE_BUTTON_CLICK, {
      container_position: containerPosition,
      mode: MODE,
      content_url:url,
    });
  };

  const handleCloseShare = () => {
    setShare(false);
  };

  const sliderSettings = {
    // removes default buttons
    dots: true,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    infinite: true,
    speed: 500,
    centerPadding: 5,
    centerMode: true,
    swipeToSlide: true,
    afterChange(index) {
      console.log(`Slider Changed to: ${index + 1}, background: #222; color: #bada55`);
    },
    focusOnSelect: true,
    touchMove: true,
  };

  let sliderImageClasses = ['view', 'round_button', 'slider_image'];
  sliderImageClasses = sliderImageClasses.join(' ');

  return (
    <div>
      <Slider ref={setSliderRef} {...sliderSettings}>
        {post.map((video, index) => (
          <div key={index} className="item">
            <div className="container">
              <img
                className={sliderImageClasses}
                src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                width="150vh"
                height="220px"
              />
              <div className="mask flex-center">
                <img
                  className="slider_play"
                  src={Play}
                  alt="alt text"
                  onClick={() => {
                    handleClickOpen(video.id);
                    triggerContentInteractedEvent(ANALYTICS_EVENTS.VIDEO_PLAYED, {
                      content_url:video.url,
                      container_position: video.containerPosition,
                    });
                  }}
                />
              </div>

              <div className="likeAndShare">
                <IconButton
                  aria-label="like"
                  style={{ color: likedItems.includes(video.id) ? 'orange' : 'white' }}
                  onClick={() => {
                    triggerContentInteractedEvent(ANALYTICS_EVENTS.VIDEO_LIKE_BUTTON_CLICK, {
                      content_url:video.url,
                      container_position: video.containerPosition,
                    });
                    getUpdatedSelectedLikeButton(video.id);
                  }}
                >
                  <ThumbUpIcon />
                </IconButton>

                <IconButton
                  aria-label="share"
                  style={{ color: 'white' }}
                  color="primary"
                  onClick={() => {
                    handleClickShare(video.id, video.url, video.containerPosition);
                  }}
                >
                  <ShareIcon />
                </IconButton>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      <>
        <ModalVideo
          channel="youtube"
          autoplay
          isOpen={open}
          videoId={currentVideoId}
          theme="dark"
          onClose={() => setOpen(false)}
        />
      </>

      <DialolPopup shareUrl={currentVideoLink} open={share} onClose={handleCloseShare} />
    </div>
  );
}

//   <Whatsapp solid medium message="Share on Whatsapp" link="http://sharingbuttons.io"/>
